import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AboutPageComponent } from './components/pages/about-page/about-page.component';
import { HomeDemoTwoComponent } from './components/pages/home-demo-two/home-demo-two.component';
import { NotFoundComponent } from './components/pages/not-found/not-found.component';
import { PrivacyPolicyPageComponent } from './components/pages/privacy-policy-page/privacy-policy-page.component';
import { SignInPageComponent } from './components/pages/sign-in-page/sign-in-page.component';
import { SignUpPageComponent } from './components/pages/sign-up-page/sign-up-page.component';
import { TermsOfServicePageComponent } from './components/pages/terms-of-service-page/terms-of-service-page.component';
import { AfroTechConnectComponent } from './components/pages/afrotech-connect/afrotech-connect.component';
import { ConfirmEmailComponent } from './components/common/confirm-email/confirm-email.component';
import { ResetPasswordComponent } from './components/common/reset-password/reset-password.component';
import { ResetPasswordRequestComponent } from './components/common/reset-password-request/reset-password-request.component';

const routes: Routes = [
    {
        path: '', 
        component: HomeDemoTwoComponent
    },
    {path: 'confirm-email', title: "AfroTech Hub - Confirmation de l'email", component: ConfirmEmailComponent},
    {path: 'afrotech-connect', component: AfroTechConnectComponent}, 
    {path: 'about-us', title: 'AfroTech Hub - À propos de nous', component: AboutPageComponent},
    {path: 'terms-of-service', title: "AfroTech Hub - Termes d'utilisation", component: TermsOfServicePageComponent},
    {path: 'privacy-policy', component: PrivacyPolicyPageComponent},
    {path: 'sign-in', title: 'AfroTech Hub - Se connecter', component: SignInPageComponent},
    {path: 'sign-up', component: SignUpPageComponent},
    { path: 'reset-password', component: ResetPasswordComponent },
    { path: 'forgot-password', component: ResetPasswordRequestComponent },
    { path: 'news', loadChildren: () => import('./components/modules/news/news.module').then(m => m.NewsModule) },
    { path: 'afrotech-learn', loadChildren: () => import('./components/modules/learn/learn.module').then(m => m.LearnModule) },
    { path: 'afrotech-solutions', loadChildren: () => import('./components/modules/solutions/solutions.module').then(m => m.SolutionsModule) },
    { path: 'afrotech-talents', loadChildren: () => import('./components/modules/talent/talent.module').then(m => m.TalentModule) },
    { path: 'contact', loadChildren: () => import('./components/pages/contact/contact.module').then(m => m.ContactModule) },


    // Here add new pages component

    {path: '**', component: NotFoundComponent} // This line will remain down from the whole pages component list
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {useHash: false, initialNavigation: 'enabledBlocking' })],
    exports: [RouterModule]
  })
  export class AppRoutingModule { }
  
